<template>
  <div class="aside__subblock">
    <div class="aside__list">
      <div class="aside__item">
        <Select
          v-model="user.select"
          title="Выберите письмо"
          :select-data="getCourses"
          placeholder="Выберите письмо"
          icon="arrow-down-thick"
        ></Select>
      </div>
      <div class="aside__item">
        <Input
          v-model.trim="user.email"
          title="Email"
          placeholder="example@email.com"
          :error="$v.$dirty && (!$v.user.email.required || !$v.user.email.email)"
          @keyup="compare"
        >
          <span v-if="$v.$dirty && !$v.user.email.required" class="form-item__error">
            Обязательное поле
          </span>
          <span v-else-if="$v.$dirty && !$v.user.email.email" class="form-item__error">
            Некорректный email
          </span>
        </Input>
      </div>
      <div class="aside__item">
        <Input v-model.trim="user.name" title="Имя" placeholder="Дмитрий" @keyup="compare"></Input>
      </div>
      <div class="aside__item">
        <Input
          v-model.trim="user.lastname"
          title="Фамилия"
          placeholder="Смирнов"
          @keyup="compare"
        ></Input>
      </div>
      <div class="aside__item">
        <Input
          v-model.trim="user.patronymic"
          title="Отчество"
          placeholder="Отчество"
          @keyup="compare"
        ></Input>
      </div>
      <div class="aside__item">
        <Input
          v-model.trim="user.phone"
          title="Телефон"
          placeholder="+79991234567"
          @keyup="compare"
        ></Input>
      </div>
      <div class="aside__item">
        <Input v-model.trim="user.city" title="Город" placeholder="Москва" @keyup="compare"></Input>
      </div>
      <div class="aside__item">
        <Input
          v-model.trim="user.site"
          title="Личный сайт"
          placeholder="Укажите ссылку"
          @keyup="compare"
        ></Input>
      </div>
      <div class="aside__item">
        <Input
          v-model.trim="user.niche"
          title="Ниша бизнеса"
          placeholder="Укажите нишу"
          @keyup="compare"
        ></Input>
      </div>
      <div class="aside__item">
        <Input
          v-model.trim="user.profitPerYear"
          title="Оборот за прошлый год"
          placeholder="1 000 000 000"
          type="number"
          @keyup="compare"
        ></Input>
      </div>
      <div class="aside__item">
        <Input
          v-model.trim="user.profitPerLastYear"
          title="Чистая прибыль за прошлый год"
          placeholder="1 000 000 000"
          type="number"
          @keyup="compare"
        ></Input>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import { required, email } from 'vuelidate/lib/validators';

export default {
  props: {
    value: {}
  },
  data: () => ({
    user: {
      select: '',
      email: '',
      name: '',
      lastname: '',
      phone: '',
      city: '',
      site: '',
      niche: '',
      profitPerYear: '',
      profitPerLastYear: ''
    },
    userBackup: {
      select: '',
      email: '',
      name: '',
      lastname: '',
      phone: '',
      city: '',
      site: '',
      niche: '',
      profitPerYear: '',
      profitPerLastYear: ''
    }
  }),
  computed: {
    ...mapState('users', {
      canSave: s => s.aside.meta.canSave
    }),
    ...mapState('auth', {
      courses: s => s.data.courses
    }),
    getCourses() {
      let arr = [];
      if (this.courses.length > 0) {
        arr = this.courses.map(el => {
          return { ...el, text: el.name };
        });
      }

      return arr;
    }
  },
  watch: {
    value() {
      this.user = _.cloneDeep(this.value);
      if (!this.user.select) {
        this.user.select = typeof this.user.id === 'undefined' ? 'withoutEmail' : 'withoutCourse';
      }
      this.userBackup = _.cloneDeep(this.user);
    },
    'user.select': function () {
      this.compare();
    }
  },
  mounted() {
    this.user = _.cloneDeep(this.value);
    this.userBackup = _.cloneDeep(this.user);
  },
  methods: {
    compare() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        if (this.canSave) {
          this.$store.dispatch('users/setAsideMeta', {
            path: 'canSave',
            value: false
          });
        }
        return;
      }

      if (!this.user.select) {
        this.user.select = typeof this.user.id !== 'undefined' ? 'withoutEmail' : 'withoutCourse';
      }

      const formHasChanges = !_.isEqual(this.user, this.userBackup);
      if (this.canSave !== formHasChanges) {
        this.$emit('compare', this.user);
      }

      if (this.canSave) {
        this.$store.dispatch('users/setAsideData', {
          path: 'user',
          value: this.user
        });
      }
    }
  },
  validations() {
    return {
      user: {
        email: { required, email }
      }
    };
  }
};
</script>
